import { mdbContainer, mdbRow, mdbCol, mdbCardBody, mdbCard } from "mdbvue";
import { mapActions } from "vuex";
import Btn from "../../../../core/Button";
import Popup from "../../../../core/Popup";
import Swal from "sweetalert2";
import { required, maxLength } from "vuelidate/lib/validators";
import ValidationError from "../../../misc/ValidationError";
import Loader from "../../../../core/Loader";
import vSelect from "vue-select";
import Paginator from "../../../../core/Paginator.vue"
const Membership = {
    name: "Membership",
    components: {
        Loader,
        "v-select": vSelect,
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCardBody,
        mdbCard,
        Btn,
        Popup,
        ValidationError,
        Paginator
    },
    data() {
        return {
            columns: [
                {
                    label: 'Accion',
                    key: 'membershipName',
                    sort: false,
                    class: 'text-left',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff",
                        "border-top-left-radius": "5px",
                        "border-bottom-left-radius": "5px"
                    },
                    tdClass: "tableCol-start",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: 'Número de usuarios',
                    key: 'beneficiariesByMembership',
                    sort: false,
                    class: 'text-left',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: 'Precio',
                    key: 'price',
                    sort: false,
                    class: 'text-left',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: '', 
                    key: 'options', 
                    sort: false, 
                    class: 'text-center', 
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 2.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
            ],

            search: '',
            isLoading: true,
            totalOfElements: 0,
            page: 1,
            perPage: 10,
            listBeneficiariesByMembership: [1, 2, 3, 4, 5],
            numberOfPages: 0,
            dataList: [],
            classPop: "popup__header-admin",
            isEdit: false,
            id: "",
            membershipName: "",
            description: "",
            beneficiariesByMembership: "",
            price: "",
            cloneMembershipName: "",
        }
    },
    validations: {
        membershipName: {
            required
        },
        description: {
            required
        },
        beneficiariesByMembership: {
            required
        },
        price: {
            required,
            maxLength: maxLength(5)
        },
    },
    methods: {
        ...mapActions([
            "_createMembership",
            "_updateMembership",
            "_deleteMembership",
            "_getMembership",
        ]),
        cleanData() {
            this.totalOfElements = 0;
            this.page = 1;
            this.perPage = 10;
            this.numberOfPages = 0;
            this.search = "";
            this.dataList = [];
        },
        async getMemberships() {
            try {
                this.isLoading = true;
                const params = {
                    pageSize: this.perPage,
                    pageNumber: this.page - 1,
                    membershipName: this.search
                };
                const { data } = await this._getMembership(params);
                if (data.status === 200) {
                    const { data: memberships, totalElements, totalPages } = data;
                    this.numberOfPages = totalPages;
                    this.totalOfElements = totalElements;
                    this.dataList = memberships;
                } else {
                    this.pushNotifyError();
                }
            }
            catch (error) {
                if (error && error.response && error.response.status === 404) {
                    this.dataList = [];
                } else {
                    this.pushNotifyError();
                }
            }
            finally {
                this.isLoading = false;
            }
        },
        async deleteMembership() {
            try {
                this.closeModal('delete');
                this.isLoading = true;
                const { data } = await this._deleteMembership({
                    id: this.id
                });
                if (data.status === 200) {
                    this.cleanData();
                    this.getMemberships();
                    this.alertSuccess(
                        'ELIMINACIÓN CORRECTA',
                        'Acción eliminada correctamente.'
                    );
                } else {
                    this.pushNotifyError();
                }
            }
            catch (error) {
                this.pushNotifyError();
            }
            finally {
                this.isLoading = false;
            }
        },
        async createMembership() {
            try {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.closeModal('persist');
                this.isLoading = true;
                const body = {
                    membershipName: this.membershipName,
                    description: this.description,
                    beneficiariesByMembership: this.beneficiariesByMembership,
                    price: Number(this.price),
                };
                const { data } = await this._createMembership(body);
                if (data.status === 201) {
                    this.cleanData();
                    this.getMemberships();
                    this.alertSuccess(
                        'REGISTRO CORRECTO',
                        'Registro de acción realizado correctamente.'
                    );
                }
                else {
                    this.pushNotifyError();
                }
            }
            catch (error) {
                if (error && error.response && error.response.data && error.response.data.errorDetails) {
                    this.pushNotifyError(error.response.data.errorDetails);
                } else {
                    this.pushNotifyError();
                }
            }
            finally {
                this.isLoading = false;
            }
        },
        async updateMembership() {
            try {

                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.closeModal('persist');
                this.isLoading = true;
                const params = {
                    id: this.id,
                    body: {
                        description: this.description,
                        beneficiariesByMembership: this.beneficiariesByMembership,
                        price: this.price,
                    }
                };

                if (this.cloneMembershipName !== this.membershipName) {
                    Object.assign(params.body, { membershipName: this.membershipName })
                }

                const { data } = await this._updateMembership(params);
                if (data.status === 200) {
                    this.cleanData();
                    this.getMemberships();
                    this.alertSuccess(
                        'EDICIÓN CORRECTA',
                        'Edición de acción realizada correctamente.'
                    );
                } else {
                    this.pushNotifyError();
                }
            }
            catch (error) {
                if (error && error.response && error.response.data && error.response.data.errorDetails) {
                    this.pushNotifyError(error.response.data.errorDetails);
                } else {
                    this.pushNotifyError();
                }
            }
            finally {
                this.isLoading = false;
            }
        },
        closeModal(modal) {
            this.isEdit = false;
            if (modal === 'delete') {
                this.$refs.deleteModal.toggleModal();
            } else {
                this.$refs.persistModal.toggleModal();
            }
        },
        openCreateSellerModal() {
            this.isEdit = false;
            this.id = "";
            this.membershipName = "";
            this.description = "";
            this.beneficiariesByMembership = "";
            this.price = "";
            this.$refs.persistModal.toggleModal();
        },
        openEditModal({ id, membershipName, description, beneficiariesByMembership, price }) {
            this.isEdit = true;
            this.membershipName = membershipName;
            this.cloneMembershipName = membershipName;
            this.description = description;
            this.beneficiariesByMembership = beneficiariesByMembership;
            this.price = price;
            this.id = id;
            this.$refs.persistModal.toggleModal();
        },
        openDeleteModal(id) {
            this.id = id;
            this.$refs.deleteModal.toggleModal();
        },
        pushNotifyError(message = "Ha ocurrido un error, inténtalo más tarde.") {
            this.$notify.error({
                message,
                position: "top right",
                timeOut: 15000
            });
        },
        alertSuccess(title, message) {
            Swal.fire({
                title:
                    `<span style='font-family: Josefin Sans,serif; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;' >${title} </span>`,
                html:
                    "<div>" +
                    `<span class='mt-4'  style='font-family: Open Sans; font-size: 14px; color: #828282; font-weight: normal'>${message}</span>` +
                    "<br>" +
                    "<img alt='success_icon' src='/img/icons/ok.svg' style='width: 40%; margin-top: 3rem;' />" +
                    "</div>",
                width: "50rem",
                padding: "4rem",
                showConfirmButton: false,
                showCloseButton: true
            });
        },
        changePage(value) {
            this.page = value
        },
        changePerPage(value) {
            this.perPage = value
        },
        toMoney(text) {
            var formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            });

            return formatter.format(text);
        },
    },
    mounted() {
        this.cleanData();
        this.getMemberships();
    },
    watch: {
        search() {
            this.getMemberships();
        },
        page() {
            this.getMemberships();
        },
        perPage() {
            this.getMemberships();
        },
    },
};

export default Membership;